import type { Permission } from "~/types/auth.type";

export const canAccessGeneralSettings = (permissions: Permission): boolean =>
  !!permissions.room?.name?.update ||
  !!permissions.room?.type?.update ||
  !!permissions.room?.delete ||
  !!permissions.room?.floor?.update;

export const canAccessTemperatureSettings = (permissions: Permission) =>
  permissions.room?.comfortTemperature?.update || permissions.room?.nightTemperature?.update;

export const canAccessFrostFreeSettings = (permissions: Permission) => permissions.room?.frostFree?.update;

export const canAccessFunctionsSettings = (permissions: Permission) =>
  !!permissions.room?.isSwitchEnabled?.update ||
  !!permissions.room?.isAutoPrecomf?.update ||
  !!permissions.room?.isPreComfRoom?.update ||
  !!permissions.room?.covSensorParam?.status?.update ||
  !!permissions.room?.covSensorParam?.status?.read ||
  !!permissions.room?.covSensorParam?.periods?.update ||
  !!permissions.room?.soundSensorParam?.status?.update ||
  !!permissions.room?.soundSensorParam?.status?.read;

export const canAccessCalibrationSettings = (permissions: Permission): boolean =>
  !!permissions.valve?.commands?.temperatureCorrectionCoef?.update;

export const canAccessPlanning = (permissions: Permission): boolean =>
  !!permissions.planning?.create || !!permissions.planning?.update;
